import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { Binder } from "./binder";

const variants = cva("", {
  variants: {
    layout: {
      grid: "grid gap-10",
      row: "block space-y-10",
    },
  },
  compoundVariants: [
    {
      layout: "grid",
      size: "sm",
      className: "grid-cols-2 sm:grid-cols-4 md:grid-cols-6",
    },
    {
      layout: "grid",
      size: "lg",
      className: "grid-cols-2 sm:grid-cols-3 md:grid-cols-4",
    },
  ],
  defaultVariants: {
    layout: "grid",
    size: "lg",
  },
});

export const Binders = ({
  className,
  binders = [],
  maxCount = 100,
  layout = "grid",
  size = "lg",
}) => {
  return (
    <div className={cn(variants({ layout, size, className }))}>
      {binders.map((binder, index) => {
        if (maxCount && index >= maxCount) return null;
        return (
          <Binder key={index} binder={binder} layout={layout} size={size} />
        );
      })}
    </div>
  );
};
